import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FormatListBulletedSharpIcon from "@mui/icons-material/FormatListBulletedSharp";
import { Grid2, IconButton } from "@mui/material";
import { ColDef, EditableCallbackParams } from "ag-grid-community";
import React, { useMemo } from "react";
import { Setting } from "../../models/Setting";

type Props = {
	setOpenModalEditSetting: Function;
	setOpenModalDeleteSetting: Function;
	showContextMenu: Function;
	setSettingSelected: (setting: Setting | null) => void;
};

export const useTableData = ({
	setOpenModalEditSetting,
	setOpenModalDeleteSetting,
	showContextMenu,
	setSettingSelected,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "SettingName",
			headerName: "Name",
			minWidth: 180,
			flex: 4,
		},
		{
			field: "Value",
			headerName: "Value",
			minWidth: 180,
			flex: 2,
		},
		{
			field: "Description",
			headerName: "Description",
			minWidth: 150,
			flex: 4,
		},
		{
			cellRenderer: (params: EditableCallbackParams) => {
				return (
					<Grid2
						container
						sx={{
							height: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",

							opacity: 0,
							transition: "opacity 0.1s ease-in-out",
							".ag-row-hover &": {
								opacity: 1,
							},
							".ag-row-focus &": {
								opacity: 1,
							},
							".ag-row-selected &": {
								opacity: 1,
							},
						}}
					>
						<Grid2
							size={{ xs: 12, md: 12 }}
							style={{
								display: "flex",
								justifyContent: "space-evenly",
								alignItems: "center",
							}}
						>
							<IconButton
								size="small"
								onClick={() => {
									setSettingSelected(params?.data as Setting);
									setOpenModalEditSetting(true);
								}}
							>
								<EditIcon color="primary" />
							</IconButton>
							<IconButton
								size="small"
								onClick={() => {
									setSettingSelected(params?.data as Setting);
									setOpenModalDeleteSetting(true);
								}}
							>
								<DeleteIcon color="secondary" />
							</IconButton>
							<IconButton
								size="small"
								onClick={(e) =>
									showContextMenu(e, params.data, "TableSettings")
								}
							>
								<FormatListBulletedSharpIcon color="action" />
							</IconButton>
						</Grid2>
					</Grid2>
				);
			},
			field: "",
			flex: 1,
			minWidth: 240,
			editable: false,
			autoHeight: false,
			suppressNavigable: true,
		},
	];

	const defaultColDef = useMemo<ColDef>(() => {
		return {
			sortable: true,
			wrapText: true,
			autoHeight: true,
			wrapHeaderText: true,
			suppressHeaderMenuButton: true,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		};
	}, []);

	return { columnDefs, defaultColDef };
};
